import { defineStore } from 'pinia';
import { ref } from 'vue';
import * as ChoiceApi from '../ChoiceApi'
import { AppScreenNames } from '../../Enums/ChoiceEnums';

export const useScreensStore = defineStore('ScreensStore', () => {
    const useScreenValues = ref<Record<AppScreenNames|string, boolean>>({});

    // Find out of the specified screen is to be used
    async function useScreen(screenName: AppScreenNames): Promise<boolean> {
        if (undefined === useScreenValues.value[screenName])
        {
            const result = await ChoiceApi.user.useScreen(screenName);
            if (!result)
            {
                return false;
            }

            useScreenValues.value[screenName] = result.use;
        }
        return useScreenValues.value[screenName];
    }
    
    return {useScreen, useScreenValues};
});